import { useTranslations } from 'next-intl';
import { DealerLocatorHeader as DealerLocatorHeaderBlocks } from '@cat-ecom/pcc-components';
import { DealerLocatorCreateAccountDescription } from '../dealer-locator-create-account-description';
import { useDealerLocatorDrawer } from 'components/dealer-locator/dealer-locator-drawer-context';
interface DealerLocatorHeaderProps {
  isRegistration: boolean;
  isADP: boolean;
  isWelcomeModal: boolean;
  isStoreLocationMapViewUpdateFlag: boolean;
  redirectionUrl?: string;
}

export const DealerLocatorHeader = ({
  isRegistration,
  isADP,
  isWelcomeModal,
  isStoreLocationMapViewUpdateFlag = false,
  redirectionUrl = ''
}: DealerLocatorHeaderProps) => {
  const t = useTranslations();
  const dealerLocatorDrawer = useDealerLocatorDrawer();

  const getTitle = () => {
    if (isRegistration) {
      return `${t('STEP_1')}: ${t('REGISTER_MODAL_SELECT_DEALER_STORE')}`;
    } else if (isADP) {
      return t('GENERAL_BACK_TO', {
        0: t('CAT_MA_ASSOCIATEDDEALERS')
      });
    } else if (isWelcomeModal) {
      return t('WELCOME_TO_PARTS_COM');
    } else {
      return t('CAT_SHOPPING_PREFERENCES_SELECT_STORE');
    }
  };
  const welcomeDescription = isWelcomeModal
    ? t('WELCOME_PCC_LOGGED_IN_NO_DEALER')
    : t('CHECK_PRICE_ENTER_LOCATION');
  const dealerLocatorHeader = isRegistration ? (
    <DealerLocatorCreateAccountDescription redirectionUrl={redirectionUrl} />
  ) : (
    welcomeDescription
  );
  return (
    <DealerLocatorHeaderBlocks
      title={getTitle()}
      {...(isADP && { onBackButtonClick: dealerLocatorDrawer?.closeDrawer })}
      isStoreLocationMapViewUpdateFlag={isStoreLocationMapViewUpdateFlag}
    >
      {dealerLocatorHeader}
    </DealerLocatorHeaderBlocks>
  );
};
